import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireProduct} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable({
  providedIn: 'root',
})
export class ProductsService implements CrudService<UmpireProduct> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireProduct[]>> {
    return this.http
      .get('/products', {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpireProduct>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireProduct>> {
    return this.http
      .post<JsonApiResponse<UmpireProduct>>('/products', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireProduct>> {
    return this.http
      .get(`/products/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireProduct>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireProduct>> {
    return this.http
      .patch<JsonApiResponse<UmpireProduct>>(
        `/products/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/products/${id}`);
  }
}
